module.exports = __webpack_public_path__ + "img/bold-icon Email line.da41d9bf.svg";